function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 444.52 444.52",
    xmlSpace: "preserve",
    width: 40,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#008DB3"
    },
    d: "M369.08,215.45v-71.43c0-8.81,7.14-15.96,15.96-15.96h48.04c0-16.25-13.17-29.42-29.42-29.42H40.87 c-16.25,0-29.43,13.17-29.43,29.42v154.95h21.71c0.61-1.44,1.28-2.86,2.02-4.24c9.02-16.9,26.52-27.4,45.67-27.4 s36.66,10.5,45.68,27.4c0.74,1.38,1.41,2.8,2.02,4.24H293.6c0.61-1.44,1.28-2.86,2.02-4.24c9.02-16.9,26.52-27.4,45.67-27.4 s36.66,10.5,45.68,27.4c0.74,1.38,1.42,2.8,2.03,4.24h44.08v-51.6h-48.04C376.22,231.41,369.08,224.27,369.08,215.45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96E0DE"
    },
    d: "M433.08,128.06v103.35h-48.04c-8.82,0-15.96-7.14-15.96-15.96v-71.43c0-3.94,1.42-7.54,3.8-10.33 c2.92-3.45,7.28-5.63,12.16-5.63L433.08,128.06L433.08,128.06z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96E0DE"
    },
    d: "M137.58,128.06v103.35H59.45c-8.82,0-15.96-7.14-15.96-15.96v-71.43c0-2.19,0.44-4.27,1.23-6.17 c2.42-5.75,8.1-9.79,14.73-9.79H137.58z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.58,
    y: 128.06,
    style: {
      fill: "#96E0DE"
    },
    width: 87,
    height: 103.35
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96E0DE"
    },
    d: "M345.08,144.02v71.43c0,0.36-0.01,0.72-0.04,1.07c-0.55,8.32-7.47,14.89-15.92,14.89h-74.54V128.06 h74.54C337.93,128.06,345.08,135.21,345.08,144.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCCCCC"
    },
    d: "M444.52,294.45v0.01c0,6.32-5.12,11.44-11.44,11.44h-40.11c0.05-0.92,0.08-1.85,0.08-2.78 c0-6.93-1.4-13.79-4.05-20.11h44.08C439.4,283.01,444.52,288.13,444.52,294.45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCCCCC"
    },
    d: "M29.09,303.12c0,0.93,0.03,1.87,0.08,2.78H11.44C5.12,305.9,0,300.78,0,294.46v-0.01 c0-6.32,5.12-11.44,11.44-11.44h21.71C30.48,289.35,29.09,296.22,29.09,303.12z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCCCCC"
    },
    d: "M289.54,303.12c0,0.93,0.03,1.87,0.08,2.78h-157.1c0.05-0.92,0.08-1.85,0.08-2.78 c0-6.93-1.4-13.79-4.06-20.11H293.6C290.93,289.35,289.54,296.22,289.54,303.12z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M341.3,285.58c9.67,0,17.53,7.87,17.53,17.54s-7.86,17.54-17.53,17.54 c-9.68,0-17.54-7.87-17.54-17.54C323.76,293.45,331.62,285.58,341.3,285.58z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M80.84,285.58c9.67,0,17.54,7.87,17.54,17.54s-7.87,17.54-17.54,17.54s-17.54-7.87-17.54-17.54 C63.3,293.45,71.17,285.58,80.84,285.58z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#666666"
    },
    d: "M384.05,303.12c0,0.93-0.03,1.86-0.09,2.77c-1.43,22.33-19.98,39.99-42.66,39.99 c-22.69,0-41.24-17.66-42.67-39.99c-0.06-0.91-0.09-1.84-0.09-2.77c0-7.27,1.81-14.12,5.02-20.11 c7.19-13.47,21.39-22.64,37.74-22.64c16.44,0,30.71,9.28,37.86,22.88C382.28,289.18,384.05,295.94,384.05,303.12z M358.83,303.12 c0-9.67-7.86-17.54-17.53-17.54c-9.68,0-17.54,7.87-17.54,17.54s7.86,17.54,17.54,17.54C350.97,320.66,358.83,312.79,358.83,303.12 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#666666"
    },
    d: "M118.58,283.01c3.21,5.99,5.02,12.84,5.02,20.11c0,0.93-0.03,1.86-0.09,2.78 c-1.43,22.32-19.98,39.98-42.67,39.98c-22.68,0-41.23-17.66-42.66-39.98c-0.06-0.92-0.09-1.85-0.09-2.78 c0-7.27,1.82-14.12,5.02-20.11c7.19-13.47,21.39-22.64,37.73-22.64C97.19,260.37,111.39,269.54,118.58,283.01z M98.38,303.12 c0-9.67-7.87-17.54-17.54-17.54s-17.54,7.87-17.54,17.54s7.87,17.54,17.54,17.54S98.38,312.79,98.38,303.12z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7CF52"
    },
    d: "M433.077,264.914h-1c-10.493,0-19-8.507-19-19l0,0h20V264.914z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#76CDCE"
    },
    points: "239.58,221.06 239.58,231.41 152.58,231.41 152.58,134.06  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76CDCE"
    },
    d: "M137.58,230.71v0.7H59.45c-8.82,0-15.96-7.14-15.96-15.96v-71.43c0-2.19,0.44-4.27,1.23-6.17 L137.58,230.71z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76CDCE"
    },
    d: "M345.04,216.52c-0.55,8.32-7.47,14.89-15.92,14.89h-74.54V128.06h2L345.04,216.52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76CDCE"
    },
    d: "M433.08,193.89v37.52h-48.04c-8.82,0-15.96-7.14-15.96-15.96v-71.43c0-3.94,1.42-7.54,3.8-10.33 L433.08,193.89z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusSvgrepoCom);
export default __webpack_public_path__ + "static/media/bus-svgrepo-com.b7e021a4f3940566d0a93ac0220d0348.svg";
export { ForwardRef as ReactComponent };